
const  baseUrlforImg='http://backend.asyv.ac.rw';//for server
//const  baseUrlforImg='http://localhost:8000';//for localhost
export default baseUrlforImg;